import React  from 'react';
import { Form, Input } from 'antd';

const { Item } = Form;

const CityFormItem = ({ disabled }) => {
  return (
    <Item 
      name="ville"
      label="Ville"
      rules={[
        {
          required: true,
          message: "Merci d'entrer votre ville."
        }
      ]}
    >
      <Input disabled={disabled}/>
    </Item>
  );
};

export default CityFormItem;
